import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, onAuthStateChanged, signOut } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC0HGxnnEc6Yl471f7jZVflZ5lbv_Uh7Qk",
  authDomain: "famitry-1171a.firebaseapp.com",
  projectId: "famitry-1171a",
  // THIS IS THE CRITICAL LINE LINKING YOUR BUCKET:
  storageBucket: "famitry-1171a.firebasestorage.app",
  messagingSenderId: "788537900070",
  appId: "1:788537900070:web:7fe662c704515cb7dc3ae7",
  measurementId: "G-K0YF69B1R5"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

let analyticsInstance: any = null;
isSupported().then(yes => {
  if (yes) {
    analyticsInstance = getAnalytics(app);
  }
});

export const analytics = analyticsInstance || null;
export { onAuthStateChanged, signOut };